import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationProvider } from '@nrwl/navigation-abstract';

interface IBulkError {
  name: string;
  issue: string;
}
export interface statusDialogData {
  isLoading: boolean;
  loaderMessage: string;
  isRequestFailed: boolean;
  message: string;
  errorDescription: string;
  icon: string;
  navigateToPage: boolean;
  bulkErrors?: Array<IBulkError>;
  action?: string;
}
@Component({
  selector: 'test-status-dialog',
  templateUrl: './test-status-dialog.component.html',
  styleUrls: ['./test-status-dialog.component.scss']
})
export class TestStatusDialogComponent implements OnInit {
  isLoading: boolean;
  loaderMessage: string;
  isRequestFailed: boolean;
  message: string;
  errorDescription: string;
  icon: string;
  navigateToPage: boolean;
  bulkErrors: Array<IBulkError>;
  action: string;

  constructor(
    public dialogRef: MatDialogRef<TestStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: statusDialogData,
    private navigator: NavigationProvider
  ) {
    this.navigateToPage = false;
    this.bulkErrors = [];
    this.action = 'Add';
    this.updateData(data);
  }

  ngOnInit(): void {
    this.isLoading = this.data.isLoading;
  }
  updateData(data: statusDialogData): void {
    this.isLoading = data.isLoading;
    this.loaderMessage = data.loaderMessage;
    this.message = data.message;
    this.isRequestFailed = data.isRequestFailed;
    this.errorDescription = data.errorDescription;
    this.icon = data.icon;
    this.navigateToPage = data.navigateToPage;
    this.bulkErrors = data.bulkErrors;
    this.action = data.action ? data.action : this.action;
  }
  navigateToTestListPage(): void {
    this.navigator.navigateToDashboard(['test-list-management']);
    this.dialogRef.close();
  }
}
